import {Injectable} from "@angular/core";
import {BaseService} from "@core/service/base.service";
import {HttpClient} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";

@Injectable({providedIn: 'root'})
export class DictService extends BaseService {

  private url = 'api/dict-tables';  // URL to web api

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl():string {
    return this.url;
  }

  /**
   * 获取所有字典主表
   * @param type
   * @returns {Observable<any|any>}
   */
  getAll():Observable<any[]> {
    const url = `${this.getUrl()}/find-all`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`findAll`)),
      catchError(this.handleError<any>(`findAll`))
    );
  }

  /**
   * 搜索主表与明细
   * @param type
   * @returns {Observable<any|any>}
   */
  getAllByValue(text):Observable<any[]> {
    const url = `${this.getUrl()}/search-by-text`;
    return this.http.get<any>(url, {params: {text: text}}).pipe(
      tap(_ => this.log(`search-by-text`)),
      catchError(this.handleError<any>(`search-by-text`))
    );
  }

  /**
   * 根据主表code获取明细列表
   * @param type
   * @returns {Observable<any|any>}
   */
  getWithItemList(dictCode):Observable<any> {
    const url = `${this.getUrl()}/search-with-list`;
    return this.http.get<any>(url, {params: {dictCode: dictCode}}).pipe(
      tap(_ => this.log(`getWithItemList`)),
      catchError(this.handleError<any>(`getWithItemList`))
    );
  }

  /**
   * 获取数据字典版本
   * @returns {Observable<any|any>}
   */
  getVersion():Observable<any> {
    const url = `${this.getUrl()}/version`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`version`)),
      catchError(this.handleError<any>(`version`))
    );
  }
}

